import { styled } from "@mui/material/styles";

export const ContactUsButton = styled("div")(() => ({
  backgroundColor: "#F1F6FB",
  padding: "16px",
  gap: "12px",
  borderRadius: "16px",
  boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.30), 0px 4px 8px 3px rgba(0, 0, 0, 0.15)",
  position: "fixed",
  right: "10%",
  bottom: "5%",
  display: "none",
  cursor: "pointer",
  color: "#308CDB",

  "&:hover": {
    color: "#369CF3",
  },

  "@media screen and (max-width: 475px)": {
    zIndex: 1000,
    display: "flex",
    alignItems: "center",
    font: "600 14px Manrope",
  },
}));
